import React, { Component } from 'react';
import firebase from 'firebase';
import Select from 'react-select';
import 'moment/locale/es';
import './style.css';
import Alert from 'react-s-alert';
import moment from 'moment';
import { Pulse } from 'react-preloading-component';
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux';
import { setProgramacion } from '../../actions'
import ModalAsignar from './Components/ModalAsignar'
import { sendLog } from '../../util';

class AsignacionConductores extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tiposViajes: this.props.tiposViajes || [],
            filtro: { label: '', value: 'Todos' },
            rutas: this.props.rutas || [],
            vehiculo: { label: 'Seleccione...', value: '' },
            conductor: { label: 'Seleccione...', value: '' },
            datepicker1: '',
            fecha1: new Date(),
            isLoading: true,
            isFilter: false,
            isStarting: true,
            isModalVisible: false,
            ruta: {},
            filteredRutas: [],
            isFirstRender: true,
        }
    }

    getTiposViaje() {
        firebase.database().ref('TiposViajes').once('value').then(snap => {
            let tiposViajes = [];
            let o = { label: 'Todas las rutas', value: 'Todos' };
            tiposViajes.push(o);
            snap.forEach(element => {
                let obje = element.val();
                o = { label: obje.nombre, value: element.key };
                tiposViajes.push(o);
            });
            this.setState({ tiposViajes });
        })
    }

    componentWillMount = () => {
        setTimeout(() => {
            this.getTiposViaje();
        }, 1000);
    }


    // CAMBIAR?
    selectTipoViaje(filtro) { this.setState({ filtro }) }

    getNombreTipo = (tipo) => {
        const nombresTipos = [
            { resumido: 'pilotos', nombre: 'Pilotos en Operación' },
            { resumido: 'pilotossap', nombre: 'Pilotos en Academia' },
            { resumido: 'tcs', nombre: 'Tripulantes de Cabina en Operación' },
            { resumido: 'tcssap', nombre: 'Tripulantes de Cabina en Academia' },
            { resumido: 'persTierr', nombre: 'Personal Tierra en Operación' }
        ];
        let nombre = "";
        for (let i = 0; i < nombresTipos.length; i++) {
            if (nombresTipos[i].resumido === tipo) {
                nombre = nombresTipos[i].nombre;
            }
        }
        return nombre;
    }


    printProgramacion(data) {
        return data.map((ruta, index) => (
            <tr className='displayD' id={index} key={ruta.key} >
                <td style={{ width: 133, display: 'none' }} >{ruta.key}</td>
                <td style={{ width: 133 }} >{this.getNombreTipo(ruta.programacionF.tipo)}</td>
                <td style={{ width: 133 }} >{ruta.nombProgra}</td>
                <td style={{ width: 108 }} >{ruta.tipoF.nombre}</td>
                <td style={{ width: 108 }} >{ruta.rutaF.nombRuta}</td>
                <td style={{ width: 39 }} >{ruta.horaInicio}</td>
                <td style={{ width: 39 }} >{ruta.horaLlegada}</td>
                <td style={{ width: 97 }} >{this.getFirstWord(ruta.rutaF.inicio === undefined ? '--' : ruta.rutaF.inicio.nombre, ',')}</td>
                <td style={{ width: 105 }} >{this.getFirstWord(ruta.rutaF.destino === undefined ? '--' : ruta.rutaF.destino.nombre, ',')}</td>
                <td style={{ width: 67 }}>{this.getConductor(ruta.conductor, true)}</td>
                <td style={{ width: 61 }}>{this.getVehiculo(ruta.vehiculo, true)}</td>
                <td style={{ width: 106 }}>
                    <button
                        onClick={() => this.openModalAsignacion(ruta, index)}
                        className={this.getConductor(ruta.conductor, true) !== 'No Asignado' ? "btn btn-small-orange" : "btn btn-small-green"}>{this.getConductor(ruta.conductor, true) !== 'No Asignado' ? "Reasignar" : "Asignar"}</button>
                </td>
            </tr>
        )
        )
    }

    fillSearchElements(data) {
        let objs = [];
        data.map((ruta, index) => {
            const element = {
                ruta: ruta,
                index: index,
                key: ruta.key,
                tipo: this.getNombreTipo(ruta.programacionF.tipo),
                nombreProgra: ruta.nombProgra,
                tipoRuta: ruta.tipoF.nombre,
                nombreTipo: ruta.rutaF.nombRuta,
                inicio: ruta.horaInicio,
                llegada: ruta.horaLlegada,
                inicioNombre: this.getFirstWord(ruta.rutaF.inicio === undefined ? '--' : ruta.rutaF.inicio.nombre, ','),
                destinoNombre: this.getFirstWord(ruta.rutaF.destino === undefined ? '--' : ruta.rutaF.destino.nombre, ','),
                conductor: this.getConductor(ruta.conductor, true),
                vehiculo: this.getVehiculo(ruta.vehiculo, true)
            }
            objs.push(element);
        });
        return objs;
    }

    openModalAsignacion(ruta, index) {
        ruta.index = index;
        this.setState({ ruta });
        this.toggleModal(true);
    }


    guardarConductor = async (ruta) => {
        const { isFilter } = this.state;

        const verificarAsignacion = async (tipo, id) => {
            const snapshot = await firebase.database().ref(tipo).child(id).child('viajeAsignado').once('value');
            return snapshot.val();
        };

        if (ruta.vehiculo === '' && ruta.conductor === '') {
            if (this.state.vehiculo && this.state.vehiculo.value && this.state.conductor && this.state.conductor.value) {
                const vehiculo = this.state.vehiculo.value;
                const conductor = this.state.conductor.value;

                console.log('Vehículo enviado:', vehiculo);
                console.log('Conductor enviado:', conductor);

                const viajeAsignadoConductor = await verificarAsignacion('Empleados', conductor);
                const viajeAsignadoVehiculo = await verificarAsignacion('Vehiculos', vehiculo);

                if (viajeAsignadoConductor) {
                    Alert.warning('Conductor ya asignado a otro viaje', { effect: 'genie', position: 'bottom-right', timeout: 1500 });
                    return;
                }

                if (viajeAsignadoVehiculo) {
                    Alert.warning('Vehículo ya asignado a otro viaje', { effect: 'genie', position: 'bottom-right', timeout: 1500 });
                    return;
                }

                const p = { conductor, vehiculo };

                if (ruta.vehiculo && ruta.conductor) {  //ya tiene conductor y vehiculo asignado 
                    firebase.database().ref('Empleados').child(ruta.conductor).child('viajeAsignado').set(false);
                    firebase.database().ref('Vehiculos').child(ruta.vehiculo).child('viajeAsignado').set(false);
                    firebase.database().ref('Vehiculos').child(ruta.vehiculo).child('estado').set('Disponible');
                }

                await firebase.database().ref().child('ProgramacionDia').child(ruta.key).update(p);

                firebase.database().ref('Empleados').child(conductor).child('viajeAsignado').set(ruta.key);
                firebase.database().ref('Vehiculos').child(vehiculo).child('viajeAsignado').set(ruta.key);
                firebase.database().ref('Vehiculos').child(vehiculo).child('estado').set('Asignado');

                this.setState({ conductor: null, vehiculo: null });
                !isFilter
                    ? null //this.getProgramacionDia(empresa, programacion)
                    : null //this.getProgramacionDiaFecha(empresa, fecha1)

                Alert.success('Asignacion realizada con exito', { effect: 'genie', position: 'bottom-right', timeout: 3000 });
                this.setState({ isModalVisible: false });
                sendLog({ tipo: 'vehiculo_conductor_asignado', informacion_extra: { asignacion: p, programacionDia: ruta.key } });

            } else {
                Alert.warning('Se debe seleccionar conductor y vehículo antes de asignar', { effect: 'genie', position: 'bottom-right', timeout: 1500 });
            }
        } else {
            if (this.state.vehiculo && this.state.vehiculo.value && this.state.conductor && this.state.conductor.value) {
                const vehiculo = this.state.vehiculo.value;
                const conductor = this.state.conductor.value;

                console.log('Conductor enviado:', conductor);
                console.log('Vehículo enviado:', vehiculo);

                const viajeAsignadoConductor = await verificarAsignacion('Empleados', conductor);
                const viajeAsignadoVehiculo = await verificarAsignacion('Vehiculos', vehiculo);

                if (viajeAsignadoConductor) {
                    Alert.warning('Conductor ya asignado a otro viaje', { effect: 'genie', position: 'bottom-right', timeout: 1500 });
                    return;
                }

                if (viajeAsignadoVehiculo) {
                    Alert.warning('Vehículo ya asignado a otro viaje', { effect: 'genie', position: 'bottom-right', timeout: 1500 });
                    return;
                }

                if (ruta.conductor)
                    firebase.database().ref('Empleados').child(ruta.conductor).child('viajeAsignado').set(false);

                if (ruta.vehiculo)
                    firebase.database().ref('Vehiculos').child(ruta.vehiculo).update({
                        estado: 'Disponible',
                        viajeAsignado: false
                    });

                await firebase.database().ref().child('ProgramacionDia').child(ruta.key)
                    .update({ conductor, vehiculo });

                firebase.database().ref('Empleados').child(conductor).child('viajeAsignado').set(ruta.key);
                firebase.database().ref('Vehiculos').child(vehiculo).child('viajeAsignado').set(ruta.key);
                firebase.database().ref('Vehiculos').child(vehiculo).child('estado').set('Asignado');

                this.setState({ conductor: null, vehiculo: null });
                this.setState({ isModalVisible: false });
                sendLog({ tipo: 'vehiculo_conductor_editado', informacion_extra: { vehiculo, conductor, programacionDia: ruta.key } });

                Alert.success('Cambios realizados con éxito', { effect: 'genie', position: 'bottom-right', timeout: 3000 });
            } else {
                Alert.warning('Proporcione datos de conductor y vehiculo a modificar', { effect: 'genie', position: 'bottom-right', timeout: 3000 });
            }
        }
        this.props.actualizar();
    }

    addCond = (conductor) => {
        if (!conductor.viajeAsignado) {
            this.setState({ conductor })
        } else {
            Alert.warning('Este conductor posee viaje activo, favor finalizarlo antes', { effect: 'genie', position: 'bottom-right', timeout: 3000 });
            this.setState({
                conductor: { label: 'Seleccione...', value: '' },
            })
        }
    }

    addCar = (vehiculo, ruta) => {
        if (vehiculo.estado === 'Disponible') {
            if (vehiculo.empresas !== undefined) {
                let vehiFind = vehiculo.empresas.find(x => ruta.solicitante === x)
                if (vehiFind === undefined || vehiFind === null) {
                    this.setState({ vehiculo: { label: "Seleccione...", value: "" } })
                    Alert.warning('El uso de este vehiculo no esta habilitado para esta empresa', { effect: 'genie', position: 'bottom-right', timeout: 1500 });
                } else {
                    this.setState({ vehiculo })
                }
            } else {
                this.setState({ vehiculo: { label: "Seleccione...", value: "" } })
                Alert.warning('Este vehiculo no esta vinculado a ninguna empresa favor contactar a soporte', { effect: 'genie', position: 'bottom-right', timeout: 1500 });
            }
        } else {
            firebase.database().ref('ProgramacionDia/' + vehiculo.viajeA).once('value').then(snap => {
                let valor = snap.val();
                if (valor) {  //existe la programacion dia
                    if (valor.estado === 'Finalizado') {
                        this.setState({ vehiculo })
                    } else {
                        this.setState({ vehiculo: { label: "Seleccione...", value: "" } })
                        Alert.warning('Este vehiculo esta asigando a un viaje que no ha finalizado', { effect: 'genie', position: 'bottom-right', timeout: 2500 });
                    }
                } else {  //no existe la pramacion dia

                }
            })
        }
    }


    getFirstWord(s, separator) {
        let r = s.split(separator);
        return r[0];
    }

    getConductor(conductor, isName) {
        let res = this.props.conductores.filter(c => c.value === conductor);
        return res.length > 0 ? isName ? res[0].label : res[0].value : 'No Asignado';
    }

    getVehiculo(vehiculo, isName) {
        let res = this.props.vehiculos.filter(c => c.value === vehiculo);
        return res.length > 0 ? isName ? res[0].label : res[0].value : 'No Asignado';
    }

    handleChangeDatePicker1() {
        const fecha = this.fecha1.value;
        const splitfecha = fecha.split("-");

        if (splitfecha[0] < 2019) return;

        const formatdate = new Date(splitfecha[0] + '/' + splitfecha[1] + '/' + splitfecha[2]);
        this.props.cambiarFecha(formatdate);

    }

    getProgramacionDiaFecha = (empresa, fecha1) => {
        let findProgra = []
        let { programacion } = this.state;
        firebase.database().ref('ProgramacionDia').orderByChild('fecha').equalTo(String(fecha1)).once('value').then(snap => {
            let programacionDia = [];
            snap.forEach(element => {
                let datos = element.val();
                let obje = {};
                findProgra = programacion.find(pfind => {
                    return pfind.key === datos.programacion;
                })
                if (empresa.value === 0) {
                    let splitH = datos.horaInicio.split(":");
                    let now = moment().hour(Number(splitH[0])).minute(Number(splitH[1])).format('HH:mm');
                    let fecha = new Date(datos.fecha);
                    let hoy = new Date(fecha1);
                    if ((new Date(fecha.getFullYear(), fecha.getMonth(), fecha.getDate()).getTime() === new Date(hoy.getFullYear(), hoy.getMonth(), hoy.getDate()).getTime())) {
                        obje = { ...datos, key: element.key, horaInicio: now, solicitante: findProgra.solicitante };
                        obje['estadoViaje'] = datos.estado
                        programacionDia.push(obje);
                    }
                } else {
                    if (findProgra.solicitante === empresa.value) {
                        let splitH = datos.horaInicio.split(":");
                        let now = moment().hour(Number(splitH[0])).minute(Number(splitH[1])).format('HH:mm');
                        let fecha = new Date(datos.fecha);
                        let hoy = new Date(fecha1);
                        if ((new Date(fecha.getFullYear(), fecha.getMonth(), fecha.getDate()).getTime() === new Date(hoy.getFullYear(), hoy.getMonth(), hoy.getDate()).getTime())) {
                            obje = { ...datos, key: element.key, horaInicio: now, solicitante: findProgra.solicitante };
                            obje['estadoViaje'] = datos.estado
                            programacionDia.push(obje);
                        }
                    }
                }
            });
            // this.mergeRutas(programacionDia, programacion);
        })
    }

    handleFiltering = (evt, data) => {

        const searchValue = evt.target.value.toLowerCase().trim().split(' ');
        let filteredRutas = []

        data.filter((ruta, i) => {
            let res = false;
            for (const prop in ruta) {
                if (searchValue.length == 1) {
                    if (String(ruta[prop]).toLocaleLowerCase().includes(searchValue[0])) res = true;
                } else {
                    //al menos 2 palabras de busqueda

                    let coincidencias = 0;
                    searchValue.forEach((value, i) => {
                        if (String(ruta[prop]).toLocaleLowerCase().includes(value))
                            coincidencias++;
                    });

                    if (coincidencias >= searchValue.length) res = true
                }
            }
            if (res) {

                filteredRutas.push(data[i].ruta);
            }
            return res;
        });
        this.setState({ filteredRutas: filteredRutas, isFirstRender: false });
    }


    toggleModal = (value) => {
        this.setState({ isModalVisible: value })
        this.setState({ conductor: null, vehiculo: null });
    }

    render() {

        let { filtro, isLoading } = this.props;
        let elementos = [];
        if (this.state.isFirstRender) {
            elementos = this.props.filteredRutas;
        } else {
            elementos = this.state.filteredRutas;
        }

        const filterRutas = elementos.filter(obje => {
            let hora = obje.horaInicio.split(':');
            let fecha = new Date(obje.fecha);
            let fechaActu = new Date();
            let fechaCom = new Date(fecha.getFullYear(), fecha.getMonth(), fecha.getDate(), hora[0], hora[1]);
            let fechaComA = new Date(fechaActu.getFullYear(), fechaActu.getMonth(), fechaActu.getDate(), fechaActu.getHours());
            // if (fechaCom.getTime() >= fechaComA.getTime()) 
            return fechaCom.getTime() >= fechaComA.getTime() && (obje.estadoViaje === "Pendiente" || obje.estadoViaje === "sinced")
        }).filter((dato => this.state.filtro.value === 'Todos' ? true : ('' + dato.rutaF.tipoViaje === this.state.filtro.value)));
        const searchData = this.fillSearchElements(this.props.filteredRutas);
        let minDate = moment(new Date()).format('YYYY-MM-DD')
        let i = 0;
        return (
            <div>
                {
                    this.state.isModalVisible &&
                    <ModalAsignar
                        close={this.toggleModal}
                        guardar={this.guardarConductor}
                        viaje={this.state.ruta}
                        vehiculos={this.props.vehiculosFiltered}
                        vehiculoSeleccionado={this.state.vehiculo}
                        conductores={this.props.conductoresFiltered}
                        conductorSeleccionado={this.state.conductor}
                        addCar={this.addCar}
                        addCond={this.addCond}
                        isAsignado={this.getConductor(this.state.ruta.conductor, true)}
                    />
                }
                <div className="row">
                    <div className="col-12 col-md-8">
                        <form>
                            <div className="row">
                                <div className="col-sm-3 col-xs-3">
                                    <div className="form-group">
                                        <label className="col-form-label">Rutas</label>
                                        <Select placeholder='Seleccione...' value={filtro} className="css-10nd86i-2" onChange={(e) => this.selectTipoViaje(e)} options={this.state.tiposViajes} />
                                    </div>
                                </div>
                                <div className="col-sm-3 col-xs-3">
                                    <div className="form-group">
                                        <label className="col-form-label">Empresa</label>
                                        <Select value={this.props.empresa} className="css-10nd86i-2" onChange={(e) => this.props.changeEmpresa(e)} placeholder="Seleccione una empresa" options={this.props.empresas}></Select>
                                    </div>
                                </div>
                                <div className="col-sm-3 col-xs-3">
                                    <div className="form-group">
                                        <label className="col-form-label">Fecha</label>
                                        <input type="date" name="fecha1" min={minDate} className="form-control" onChange={this.handleChangeDatePicker1.bind(this)}
                                            ref={input => { this.fecha1 = input }}
                                        />
                                    </div>
                                </div>
                                <div className="col-sm-3 col-xs-3">
                                    <div className="form-group">
                                        <label className="col-form-label">Buscar</label>
                                        <input onChange={(e) => this.handleFiltering(e, searchData)} className="form-control" placeholder='Buscar' />
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                <div className="row justify-content-md-center">
                    <div className="col-12" style={{ marginTop: '2%' }}>
                        <div style={{ minHeight: '300px' }} className="table-responsive text-center">
                            <h4>{this.props.fecha && 'Fecha: ' + this.props.fecha}</h4>
                            <table className="paleBlueRows centerItem">
                                <thead style={{ display: 'block' }}>
                                    <tr>
                                        <th style={{ width: 136 }} >Tipo de viaje</th>
                                        <th style={{ width: 136 }} >Viaje</th>
                                        <th style={{ width: 108 }} >Ruta</th>
                                        <th style={{ width: 108 }} >Tipo de ruta</th>
                                        <th style={{ width: 39 }} >Hr. Part</th>
                                        <th style={{ width: 39 }} >Hr. Lleg</th>
                                        <th style={{ width: 98 }} >Origen</th>
                                        <th style={{ width: 105 }} >Destino</th>
                                        <th style={{ width: 67 }}>Conductor Asignado</th>
                                        <th style={{ width: 61 }}>Vehículo Asignado</th>
                                        {/* <th style={{ width: 206 }}>Asignar Conductor</th>
										<th style={{ width: 206 }}>Asignar Vehículo</th> */}
                                        <th style={{ width: 106 }}></th>
                                    </tr>
                                </thead>
                                <tbody style={{ height: '80vh', overflow: 'auto', display: 'block' }}>
                                    {
                                        this.printProgramacion(filterRutas)
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        )

    }
}

const mapStateToProps = (state) => ({
    programacionDia: state.programacionDia
})
export default connect(mapStateToProps, { setProgramacion })(withRouter(AsignacionConductores));


// WEBPACK FOOTER //
// ./src/Components/Rutas/AsignacionConductores.js